import Vue from 'vue'
import Router from 'vue-router'

import Instant from '../pages/instant';
import Cash from '../pages/cash';
import Point from '../pages/point';
import Login from '../pages/login';
import Profile from '../pages/profile';
import Follow from '../pages/follow';
import Award from '../pages/award';
import EndPage from '../pages/endpage';
import NotFound from '../pages/notFound';
import Failure from '../pages/failure';
import ErrorPage from '../pages/errorPage';

import { isLogin } from '../utils';

Vue.use(Router)

const router = new Router({
    routes: [
      { path: '/', redirect: '/instant'},
      { path: '/instant', component: Instant, meta: { requiresAuth: true }},
      { path: '/cash', component: Cash, meta: { requiresAuth: true }},
      { path: '/point', component: Point, meta: { requiresAuth: true }},
      { path: '/follow', component: Follow, meta: { requiresAuth: false }},
      { path: '/login', component: Login, meta: { requiresAuth: false }},
      { path: '/award', component: Award, meta: { requiresAuth: true }},
      { path: '/profile', component: Profile, meta: {requiresAuth: true}}, 
      { path: '/endpage', component: EndPage},
      { path: '/failure', component: Failure},
      { path: '/error', component: ErrorPage},
      { path: '*', component: NotFound}
    ]
})

// 判断是否注册，未注册跳转
router.beforeEach((to, from, next) => {
    if (to.path.search('www.beian.miit.gov.cn')) {
      console.log(`放行`);
      next();
      return;
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (isLogin()) {
        next();
      }else {
        next({ path: '/login'})
      }
    }else {
       next();
    }
})


export default router
